import { ClipboardListIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@ui/button";

import { SadieVoicePostCall } from "@/types";

// What 04 made of a finished simulated call: the recap text Sadie would send
// and the record updates. Nothing is written or sent.
export const SadieVoicePostCallPanel = ({
  isError,
  isPending,
  onRun,
  result,
}: {
  isError: boolean;
  isPending: boolean;
  onRun: () => void;
  result: SadieVoicePostCall | undefined;
}) => {
  const recap = result?.result?.recap_text;
  return (
    <Column className="gap-3 border-t border-slate-200 bg-slate-50 p-4">
      <Row className="items-center justify-between gap-3">
        <Row className="items-center gap-2">
          <ClipboardListIcon className="h-4 w-4 text-slate-400" />
          <Text className="text-sm font-medium text-slate-700">Post-call</Text>
          <Text className="text-xs text-slate-500">
            Nothing is written to a worker and no recap is sent.
          </Text>
        </Row>
        <Button
          disabled={isPending}
          onClick={onRun}
          size="sm"
          variant="outline"
        >
          {isPending ? "Running…" : result ? "Run again" : "Run post-call"}
        </Button>
      </Row>
      {isError ? (
        <Text className="text-sm text-red-600">The post-call run failed.</Text>
      ) : null}
      {result ? (
        <Column className="gap-2">
          {typeof recap === "string" ? (
            <Column className="gap-1">
              <Text className="text-[11px] font-medium uppercase tracking-wide text-slate-400">
                Recap text
              </Text>
              <Text className="max-w-[75%] whitespace-pre-wrap rounded-2xl bg-emerald-50 px-3.5 py-2 text-sm text-slate-800">
                {recap}
              </Text>
            </Column>
          ) : null}
          {result.result ? null : (
            <Text className="text-sm text-amber-700">
              The model did not return JSON. Raw output below.
            </Text>
          )}
          <pre className="max-h-80 overflow-auto whitespace-pre-wrap break-words rounded-md border border-slate-200 bg-white p-3 font-mono text-xs text-slate-700">
            {result.result
              ? JSON.stringify(result.result, null, 2)
              : result.raw}
          </pre>
        </Column>
      ) : null}
    </Column>
  );
};
